/**
 * @generated SignedSource<<e99618a678e1fdb069e0845d053950f4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  (v0/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ProfileSettingsRouteQuery",
    "selections": [
      {
        "alias": "user",
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "profile",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ProfileSettings_user"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "NotificationCycle",
        "kind": "LinkedField",
        "name": "notificationCycles",
        "plural": true,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ProfileSettings_notificationCycles"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ProfileSettingsRouteQuery",
    "selections": [
      {
        "alias": "user",
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "profile",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "NotificationSetting",
                "kind": "LinkedField",
                "name": "notificationSettings",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "NotificationCycle",
                    "kind": "LinkedField",
                    "name": "cycle",
                    "plural": false,
                    "selections": (v1/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "NotificationCategory",
                    "kind": "LinkedField",
                    "name": "category",
                    "plural": false,
                    "selections": (v1/*: any*/),
                    "storageKey": null
                  },
                  (v0/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "NotificationRecipient",
            "abstractKey": "__isNotificationRecipient"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "NotificationCycle",
        "kind": "LinkedField",
        "name": "notificationCycles",
        "plural": true,
        "selections": (v1/*: any*/),
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ef39dbdf1ac696d87c7f1e00ba71c7cb",
    "id": null,
    "metadata": {},
    "name": "ProfileSettingsRouteQuery",
    "operationKind": "query",
    "text": "query ProfileSettingsRouteQuery {\n  user: profile {\n    ...ProfileSettings_user\n    id\n  }\n  notificationCycles {\n    ...ProfileSettings_notificationCycles\n    id\n  }\n}\n\nfragment NotificationSettingsForm_notificationCycles on NotificationCycle {\n  id\n  name\n}\n\nfragment NotificationSettingsForm_recipient on NotificationRecipient {\n  __isNotificationRecipient: __typename\n  notificationSettings {\n    cycle {\n      id\n      name\n    }\n    category {\n      id\n      name\n    }\n    id\n  }\n}\n\nfragment ProfileSettingsForm_notificationCycles on NotificationCycle {\n  ...NotificationSettingsForm_notificationCycles\n}\n\nfragment ProfileSettingsForm_user on User {\n  id\n  ...NotificationSettingsForm_recipient\n}\n\nfragment ProfileSettings_notificationCycles on NotificationCycle {\n  ...ProfileSettingsForm_notificationCycles\n}\n\nfragment ProfileSettings_user on User {\n  ...ProfileSettingsForm_user\n}\n"
  }
};
})();

node.hash = "e0db6785397f48260fab68220ebd06e3";

module.exports = node;
